document.addEventListener("DOMContentLoaded", (event) => {
  console.log("The spice must flow")
})
